module.exports = __webpack_public_path__ + "img/18.3.TP.f37fbea8.png";